export class SdsMaximumUpload {
  static readonly DEFAULT = new SdsMaximumUpload(10);
  static readonly FREE_MAX = new SdsMaximumUpload(50);
  static readonly PAID_MAX = new SdsMaximumUpload(1_000_000);
  static readonly UNLIMITED = new SdsMaximumUpload(1_000_000_000);

  private constructor(readonly value: number) {}

  isFree = (): boolean => {
    return (
      this.value >= SdsMaximumUpload.DEFAULT.value &&
      this.value <= SdsMaximumUpload.FREE_MAX.value
    );
  };

  isPaid = (): boolean => {
    return (
      this.value > SdsMaximumUpload.FREE_MAX.value &&
      this.value <= SdsMaximumUpload.PAID_MAX.value
    );
  };

  isUnlimited = (): boolean => {
    return this.value === SdsMaximumUpload.UNLIMITED.value;
  };

  static fromUpload(value: number): SdsMaximumUpload {
    return new SdsMaximumUpload(value);
  }
}
